module.exports = __webpack_public_path__ + "img/ro.e6b54918.png";